var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS2N1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 49.9316C38.031 49.9316 49 38.9626 49 25.4316C49 11.9007 38.031 0.931641 24.5 0.931641C10.969 0.931641 0 11.9007 0 25.4316C0 38.9626 10.969 49.9316 24.5 49.9316Z",
    fill: "#FF4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3979 32.9316V31.2516H24.3499V20.4516H21.3979V18.7716H23.1499C24.3979 18.7716 24.7099 18.4836 24.7099 17.7876V17.4996H26.5579V31.2516H29.5099V32.9316H21.3979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS2N1);
export default __webpack_public_path__ + "static/media/HomeS2N1.d605d0c5c7e152c0601934bc70a37702.svg";
export { ForwardRef as ReactComponent };